module.exports = __webpack_public_path__ + "static/media/lock.5392138b.svg";